export const APP_NAME = 'Boulder Crest Analysis Portal'
export const PERSIST_STORE_NAME = 'admin'
export const REDIRECT_URL_KEY = 'redirectUrl'